var dataSuc = {
    "responseHeader": {
        "status": 200,
        "message": "SUCCESS",
        "params": null,
        "errors": null,
        "timestamp": 1531805741729,
        "qtime": 0
    },
    "response": {
        "result": {
            "applyId": 13761430,
            "periods": {
                "id": 1652,
                "cityId": 330,
                "activityType": 1,
                "title": "徐州第九届惠民车展",
                "beginTime": 1532134800000,
                "endTime": 1532250000000,
                "beginTimeStr": "2018-07-21 09:00:00",
                "endTimeStr": "2018-07-22 17:00:00",
                "isShowTicket": 1,
                "isTicket": 1,
                "msgTemplate": null,
                "shareTitle": "徐州第九届惠民车展7月21-22日徐州香山物流园钜惠开启",
                "shareDescribe": "订车送价值12880元新车大礼包，还可参与订车抽大奖活动",
                "shareUrl": "https://m.tuanche.com/tcj/xz/1/20181652.html",
                "shareImg": "15293682477155088.jpg",
                "promotionType": 1,
                "signHeadimg": "",
                "signText": null,
                "signSucImg": "",
                "signSucUrl": null,
                "investigationTitle": "您通过哪些途径了解本次团车节活动信息的？（可多选）",
                "investigationSampling": 100,
                "investigationTab": true,
                "exhibitionBrand": true,
                "longitude": 117.236225,
                "latitude": 34.283802,
                "longitudeLatitude": null,
                "trafficRoutes": "1、自驾线路|导航徐州市鼓楼区东三环路广山路29号|2、公交出行|16路、46路到响山东路东下沿东三环向东800米，从徐州东站乘坐3路/3w路,经过19站, 到达广山路北口站| | | | |",
                "address": "徐州香山物流园",
                "createUserId": 1531,
                "createTime": 1529368324000,
                "updateUserId": 1615,
                "updateTime": 1530847020000,
                "status": null,
                "isDelete": false,
                "trafficRoutesMapList": [
                    {
                        "1、自驾线路": "导航徐州市鼓楼区东三环路广山路29号"
                    },
                    {
                        "2、公交出行": "16路、46路到响山东路东下沿东三环向东800米，从徐州东站乘坐3路/3w路,经过19站, 到达广山路北口站"
                    }
                ],
                "isNew": null,
                "trafficCoordinate": null,
                "investigationList": [
                    {
                        "id": 113276,
                        "periodsId": 1652,
                        "channelName": "百度及360搜索引擎",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113277,
                        "periodsId": 1652,
                        "channelName": "今日头条、腾讯新闻",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113278,
                        "periodsId": 1652,
                        "channelName": "微信及腾讯新闻",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113279,
                        "periodsId": 1652,
                        "channelName": "电视台、电台广告",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113280,
                        "periodsId": 1652,
                        "channelName": "网络新闻、论坛、微博",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113281,
                        "periodsId": 1652,
                        "channelName": "户外及电梯广告",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113282,
                        "periodsId": 1652,
                        "channelName": "4S店介绍",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113283,
                        "periodsId": 1652,
                        "channelName": "朋友介绍",
                        "channelNameList": null,
                        "online": true,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113284,
                        "periodsId": 1652,
                        "channelName": "",
                        "channelNameList": null,
                        "online": false,
                        "onlineList": null,
                        "offline": false,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113285,
                        "periodsId": 1652,
                        "channelName": "",
                        "channelNameList": null,
                        "online": false,
                        "onlineList": null,
                        "offline": false,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113286,
                        "periodsId": 1652,
                        "channelName": "",
                        "channelNameList": null,
                        "online": false,
                        "onlineList": null,
                        "offline": false,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113287,
                        "periodsId": 1652,
                        "channelName": "",
                        "channelNameList": null,
                        "online": false,
                        "onlineList": null,
                        "offline": false,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113288,
                        "periodsId": 1652,
                        "channelName": "",
                        "channelNameList": null,
                        "online": false,
                        "onlineList": null,
                        "offline": false,
                        "offlineList": null,
                        "isDelete": false
                    },
                    {
                        "id": 113289,
                        "periodsId": 1652,
                        "channelName": "路过",
                        "channelNameList": null,
                        "online": false,
                        "onlineList": null,
                        "offline": true,
                        "offlineList": null,
                        "isDelete": false
                    }
                ],
                "exhibitionBrandList": [
                    {
                        "id": 569631,
                        "periodsId": 1652,
                        "brandId": 2,
                        "brandName": "上汽大众",
                        "brandLogo": "/car/20180611/15286884247957073_s.jpg",
                        "brandIdList": null,
                        "sort": 1,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569632,
                        "periodsId": 1652,
                        "brandId": 1,
                        "brandName": "一汽-大众",
                        "brandLogo": "/car/20160510/14628629039497459_s.jpg",
                        "brandIdList": null,
                        "sort": 2,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569633,
                        "periodsId": 1652,
                        "brandId": 3,
                        "brandName": "东风日产",
                        "brandLogo": "/car/20160418/14609490662115568_s.jpg",
                        "brandIdList": null,
                        "sort": 3,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569634,
                        "periodsId": 1652,
                        "brandId": 67,
                        "brandName": "宝骏",
                        "brandLogo": "/car/20180611/15286881284791800_s.jpg",
                        "brandIdList": null,
                        "sort": 4,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569635,
                        "periodsId": 1652,
                        "brandId": 4,
                        "brandName": "斯柯达",
                        "brandLogo": "/car/20180611/15286893504347539_s.jpg",
                        "brandIdList": null,
                        "sort": 5,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569636,
                        "periodsId": 1652,
                        "brandId": 5,
                        "brandName": "北京现代",
                        "brandLogo": "/car/20180611/15286888703019723_s.jpg",
                        "brandIdList": null,
                        "sort": 6,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569637,
                        "periodsId": 1652,
                        "brandId": 6,
                        "brandName": "长安福特",
                        "brandLogo": "/car/20180611/15286889477035570_s.jpg",
                        "brandIdList": null,
                        "sort": 7,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569638,
                        "periodsId": 1652,
                        "brandId": 8,
                        "brandName": "东风标致",
                        "brandLogo": "/car/20180611/15286888044118198_s.jpg",
                        "brandIdList": null,
                        "sort": 8,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569639,
                        "periodsId": 1652,
                        "brandId": 72,
                        "brandName": "凯迪拉克",
                        "brandLogo": "/car/20180611/15286876137961418_s.jpg",
                        "brandIdList": null,
                        "sort": 9,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569640,
                        "periodsId": 1652,
                        "brandId": 9,
                        "brandName": "通用别克",
                        "brandLogo": "/car/20180611/15286878840734767_s.jpg",
                        "brandIdList": null,
                        "sort": 10,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569641,
                        "periodsId": 1652,
                        "brandId": 10,
                        "brandName": "通用雪佛兰",
                        "brandLogo": "/car/20180611/15286879825352822_s.jpg",
                        "brandIdList": null,
                        "sort": 11,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569642,
                        "periodsId": 1652,
                        "brandId": 13,
                        "brandName": "广汽丰田",
                        "brandLogo": "/car/20180313/15209261516365918_s.jpg",
                        "brandIdList": null,
                        "sort": 12,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569643,
                        "periodsId": 1652,
                        "brandId": 78,
                        "brandName": "北京汽车",
                        "brandLogo": "/car/20160421/14612056720299319_s.jpg",
                        "brandIdList": null,
                        "sort": 13,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569644,
                        "periodsId": 1652,
                        "brandId": 15,
                        "brandName": "上汽荣威",
                        "brandLogo": "/car/20180611/15286881991994495_s.jpg",
                        "brandIdList": null,
                        "sort": 14,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569645,
                        "periodsId": 1652,
                        "brandId": 16,
                        "brandName": "上汽名爵",
                        "brandLogo": "/car/20180611/15286882768819019_s.jpg",
                        "brandIdList": null,
                        "sort": 15,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569646,
                        "periodsId": 1652,
                        "brandId": 18,
                        "brandName": "长安马自达",
                        "brandLogo": "/car/20180611/15286890285212085_s.jpg",
                        "brandIdList": null,
                        "sort": 16,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569647,
                        "periodsId": 1652,
                        "brandId": 23,
                        "brandName": "长安汽车",
                        "brandLogo": "/car/20171227/1514362316357787_s.jpg",
                        "brandIdList": null,
                        "sort": 17,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569648,
                        "periodsId": 1652,
                        "brandId": 24,
                        "brandName": "哈弗",
                        "brandLogo": "/car/20180502/15252558614979897_s.jpg",
                        "brandIdList": null,
                        "sort": 18,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569649,
                        "periodsId": 1652,
                        "brandId": 25,
                        "brandName": "比亚迪",
                        "brandLogo": "/car/20160418/14609487507725370_s.jpg",
                        "brandIdList": null,
                        "sort": 19,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569650,
                        "periodsId": 1652,
                        "brandId": 27,
                        "brandName": "奇瑞",
                        "brandLogo": "/car/20160418/14609489463365442_s.jpg",
                        "brandIdList": null,
                        "sort": 20,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569651,
                        "periodsId": 1652,
                        "brandId": 28,
                        "brandName": "一汽奔腾",
                        "brandLogo": "/car/20180313/15209088223892980_s.jpg",
                        "brandIdList": null,
                        "sort": 21,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569652,
                        "periodsId": 1652,
                        "brandId": 30,
                        "brandName": "吉利汽车",
                        "brandLogo": "/car/20160418/14609488955552876_s.jpg",
                        "brandIdList": null,
                        "sort": 22,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569653,
                        "periodsId": 1652,
                        "brandId": 31,
                        "brandName": "一汽-大众奥迪",
                        "brandLogo": "/car/20170615/14975150668206058_s.jpg",
                        "brandIdList": null,
                        "sort": 23,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569654,
                        "periodsId": 1652,
                        "brandId": 264,
                        "brandName": "一汽森雅",
                        "brandLogo": "/car/20180329/15222893735666053_s.jpg",
                        "brandIdList": null,
                        "sort": 24,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569655,
                        "periodsId": 1652,
                        "brandId": 99,
                        "brandName": "众泰汽车",
                        "brandLogo": "/car/20170717/15002604057602789_s.jpg",
                        "brandIdList": null,
                        "sort": 25,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569656,
                        "periodsId": 1652,
                        "brandId": 275,
                        "brandName": "众泰大迈",
                        "brandLogo": "/car/20180528/15274807172951340_s.jpg",
                        "brandIdList": null,
                        "sort": 26,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569657,
                        "periodsId": 1652,
                        "brandId": 37,
                        "brandName": "江淮汽车",
                        "brandLogo": "/car/20180619/15293940850267050_s.jpg",
                        "brandIdList": null,
                        "sort": 27,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569658,
                        "periodsId": 1652,
                        "brandId": 101,
                        "brandName": "东风风行",
                        "brandLogo": "/car/20171227/15143630828342297_s.jpg",
                        "brandIdList": null,
                        "sort": 28,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569659,
                        "periodsId": 1652,
                        "brandId": 39,
                        "brandName": "斯巴鲁",
                        "brandLogo": "/car/20180313/15209245842478994_s.jpg",
                        "brandIdList": null,
                        "sort": 29,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569660,
                        "periodsId": 1652,
                        "brandId": 234,
                        "brandName": "宝沃",
                        "brandLogo": "/car/20160427/14617563984544858_s.jpg",
                        "brandIdList": null,
                        "sort": 30,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569661,
                        "periodsId": 1652,
                        "brandId": 44,
                        "brandName": "广汽三菱",
                        "brandLogo": "/car/20180504/15254167582533519_s.jpg",
                        "brandIdList": null,
                        "sort": 31,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569662,
                        "periodsId": 1652,
                        "brandId": 236,
                        "brandName": "斯威汽车",
                        "brandLogo": "/car/20161026/14774706104143466_s.jpg",
                        "brandIdList": null,
                        "sort": 32,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569663,
                        "periodsId": 1652,
                        "brandId": 240,
                        "brandName": "WEY",
                        "brandLogo": "/car/20180419/1524123540126107_s.jpg",
                        "brandIdList": null,
                        "sort": 33,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569664,
                        "periodsId": 1652,
                        "brandId": 49,
                        "brandName": "东风风神",
                        "brandLogo": "/car/20180117/15161686144332348_s.jpg",
                        "brandIdList": null,
                        "sort": 34,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569665,
                        "periodsId": 1652,
                        "brandId": 52,
                        "brandName": "广汽传祺",
                        "brandLogo": "/car/20171227/15143643673702510_s.jpg",
                        "brandIdList": null,
                        "sort": 35,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569666,
                        "periodsId": 1652,
                        "brandId": 181,
                        "brandName": "凯翼",
                        "brandLogo": "/car/20160421/14612059884447905_s.jpg",
                        "brandIdList": null,
                        "sort": 36,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569667,
                        "periodsId": 1652,
                        "brandId": 22,
                        "brandName": "东南汽车",
                        "brandLogo": "/car/20171227/15143637706882346_s.jpg",
                        "brandIdList": null,
                        "sort": 37,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569668,
                        "periodsId": 1652,
                        "brandId": 14,
                        "brandName": "一汽丰田",
                        "brandLogo": "/car/20180517/15265479502709137_s.jpg",
                        "brandIdList": null,
                        "sort": 38,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569669,
                        "periodsId": 1652,
                        "brandId": 252,
                        "brandName": "领克",
                        "brandLogo": "/car/20170913/15052651305344815_s.jpg",
                        "brandIdList": null,
                        "sort": 39,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569670,
                        "periodsId": 1652,
                        "brandId": 11,
                        "brandName": "广汽本田",
                        "brandLogo": "/car/20180502/15252344232377553_s.jpg",
                        "brandIdList": null,
                        "sort": 40,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569671,
                        "periodsId": 1652,
                        "brandId": 259,
                        "brandName": "君马汽车",
                        "brandLogo": "/car/20171229/15145257659146771_s.jpg",
                        "brandIdList": null,
                        "sort": 41,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569672,
                        "periodsId": 1652,
                        "brandId": 36,
                        "brandName": "沃尔沃",
                        "brandLogo": "/car/20180611/15286876966534579_s.jpg",
                        "brandIdList": null,
                        "sort": 42,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569673,
                        "periodsId": 1652,
                        "brandId": 62,
                        "brandName": "东风启辰",
                        "brandLogo": "/car/20171222/15139356735359649_s.jpg",
                        "brandIdList": null,
                        "sort": 43,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569674,
                        "periodsId": 1652,
                        "brandId": 114,
                        "brandName": "红旗",
                        "brandLogo": "/car/20180625/15299013983605036_s.jpg",
                        "brandIdList": null,
                        "sort": 44,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569675,
                        "periodsId": 1652,
                        "brandId": 124,
                        "brandName": "东风风光",
                        "brandLogo": "/car/20171227/15143635309847270_s.jpg",
                        "brandIdList": null,
                        "sort": 45,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569676,
                        "periodsId": 1652,
                        "brandId": 150,
                        "brandName": "猎豹汽车",
                        "brandLogo": "/car/20170222/14877466723912294_s.jpg",
                        "brandIdList": null,
                        "sort": 46,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569677,
                        "periodsId": 1652,
                        "brandId": 17,
                        "brandName": "一汽马自达",
                        "brandLogo": "/car/20170222/14877524948496731_s.jpg",
                        "brandIdList": null,
                        "sort": 47,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    },
                    {
                        "id": 569678,
                        "periodsId": 1652,
                        "brandId": 147,
                        "brandName": "林肯",
                        "brandLogo": "/car/20140925/14116096864468847_s.jpg",
                        "brandIdList": null,
                        "sort": 48,
                        "sortList": null,
                        "isDelete": false,
                        "label": ""
                    }
                ],
                "page": null,
                "cityIds": null,
                "idList": null,
                "activityTypes": null,
                "partnerLogo": "",
                "activeBrand": null,
                "mlistImg": null,
                "ledSignin": false,
                "msgChagetime": 1529456400000,
                "msgEndtime": 1532250000000,
                "qrcodeImg": "15293681878836034.jpg",
                "weixin": "",
                "weixinNickname": "",
                "packageAmount": 12880,
                "noticeTitle": null,
                "ticketPrice": 20,
                "noticeList": [],
                "tmallUrl": "",
                "manuActiveImg": "",
                "cityWebImg": "",
                "endState": null,
                "limit": null,
                "successBannerList": [],
                "ticketPageAdList": [],
                "ticketPageGiftList": [
                    {
                        "id": 321659,
                        "periodsId": 1652,
                        "positionId": 39,
                        "imageName": "15293875855456244_s.jpg",
                        "text": "https://mp.weixin.qq.com/s/UHwBJfAyqdBSBH-CrQwrag",
                        "labelType": null,
                        "labelDesc": null,
                        "title": null,
                        "brandId": null,
                        "carStyleId": null,
                        "carModelId": null,
                        "isDelete": false,
                        "styleName": null
                    }
                ],
                "msgTemplateId": 27,
                "msgParams": ",徐州第九届惠民车展,7月21日,7月22日,徐州香山物流园,",
                "weixinRemindText": "",
                "present": true,
                "presentTips": true,
                "presentTitle": "订车送价值12880元大礼包",
                "ticketAdText": null,
                "ticketAdClicktext": null,
                "ticketAdUrl": null,
                "brandTimeCb": true,
                "ticketDetailBannerCb": null,
                "tickeDetailAdCb": null,
                "tickeDetailGiftCb": true,
                "successBannerCb": null,
                "improveInfoTextFlag": 1,
                "improveInfoText": "请填写以下信息 4张车展门票及礼品券快递到您家！",
                "improveInfoPicFlag": 1,
                "improveInfoPic": "15294820973438575_s.jpg",
                "picUrl": "/zhuanti/autoshow/",
                "ticket": 1,
                "notice": null,
                "showTmallUrl": null
            }
        }
    },
    "pageInfo": {
        "pageNum": 0,
        "pageSize": 0,
        "size": 0,
        "startRow": 0,
        "endRow": 0,
        "total": 0,
        "pages": 0,
        "prePage": 0,
        "nextPage": 0,
        "hasPreviousPage": false,
        "hasNextPage": false,
        "firstPage": false,
        "lastPage": false
    },
    "stackTrace": {
        "errorStack": null
    }
}
export default dataSuc


// WEBPACK FOOTER //
// ./src/data/dataSuc.js